import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { AlertService } from 'src/app/core/services/alert.service';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { ProductService } from 'src/app/product/services/product.service';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { environment } from 'src/environments/environment';
import { CartService } from '../../services/cart.service';
import { filter, pairwise } from 'rxjs/operators';
import { CartModuleConsts } from '../../contants';
import { SharedConsts } from 'src/app/shared/constants';


@Component({
    selector: 'app-review',
    templateUrl: './review.component.html',
    styleUrls: ['./review.component.scss'],
    standalone: false
})
export class ReviewComponent implements OnInit {
  reviewOrderList: any =[];
  previous_url ='';
  removeType = '';
  selectedCategory = '';
  removeProduct = {};
  removeHeading = '';
  failureCount = 0;
  bsModalRef: BsModalRef;
  imagePath = environment.s3_path + '/' + environment.product_image_folder + '/'
  global_data:any = {};
  constructor(private cartService: CartService, private alertService: AlertService,
    private statePersist: StatePersistService, private googleAnalyticsService: GoogleAnalyticsService,
    private modalService: BsModalService, private productService: ProductService,
    private router: Router, private toastService: ToastrService,private statePersiste: StatePersistService) {
      this.router.events
    .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
    .subscribe((events: RoutesRecognized[]) => {
      this.previous_url = events[0].urlAfterRedirects
      this.statePersist.setLocalStorage('previous_url', this.previous_url)
    });
     }

  ngOnInit(): void {
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
    this.statePersiste.watchGlobalDataStorage().subscribe(message => {
      this.global_data = this.statePersiste.getLocalStorage('global_data')
    })

    this.previous_url = this.statePersist.getLocalStorage('previous_url')
    this.statePersist.setLocalStorage('address-disabled', true)
    this.statePersist.setLocalStorage('retailer-disabled', true)
    if (this.previous_url != "/mycart") {
      this.router.navigate(['/mycart']);
     } 

    this.getCategoryProductListing()
   
  }



  removePopup(template: TemplateRef<any>, cat, selectedProduct, type) {
    this.removeProduct = selectedProduct
    this.selectedCategory = cat
    this.removeType = type
    this.removeHeading = CartModuleConsts.REMOVEPOPUPMESSAGE
    this.bsModalRef = this.modalService.show(template,  Object.assign({}, { class: 'modal-dialog-centered custom-modal confirm' }));
  }

  getCategoryProductListing() {
    this.cartService.getReviewOrder({})
    .subscribe(
      data => {
        if (data.response) {
          if (data.status == 1144) {
            this.toastService.error(data.response);
            this.statePersist.setLocalStorage('product_data', {'brand_filter':''});
            this.router.navigate(['/product/listing/All']);
          }
          else if (data.status == 1145){
            this.toastService.error(data.response)
          }
          else if(data.status == 1180){
            localStorage.setItem('closeStorInfoMessage', data.response.msg)
            document.getElementById("openclosedStoreInfo").click();
          }
          else{
            this.reviewOrderList = data.response
            if (this.reviewOrderList.length == 0){
              this.validate()
            }
            for (let i = 0; i < this.reviewOrderList.length; i++) {
              var current_limit = 0
              var dataObj = this.reviewOrderList[i].items
              for (let j = 0; j < dataObj.length; j++){
                current_limit += dataObj[j].item_qty
              }
              if (current_limit != 0){
                this.reviewOrderList[i]['current_cart_qty'] = current_limit
              }
              else{
                this.reviewOrderList[i]['current_cart_qty'] = null
              }
              
              
              }
            
          }
         
        }
      }
    );
  }

  categoryCartLimitUpdate(cat_obj){
    var data = this.reviewOrderList.filter(cat => cat.category_id == cat_obj.category_id)[0]
    var current_limit = 0;
    for (let i = 0; i < data.items.length; i++){
      current_limit += data.items[i].item_qty
    }
    if (current_limit != 0){
      this.reviewOrderList.find(cat => cat.category_id == cat_obj.category_id)['current_cart_qty'] = current_limit
    }
    else{
      this.reviewOrderList.find(cat => cat.category_id == cat_obj.category_id)['current_cart_qty']  = null
    }
    var new_array = this.reviewOrderList
    this.reviewOrderList = new_array
  }

  toInteger(value) {
    return parseInt(value)
  }

  updateCategoryArray(product, cat){
    var category = this.reviewOrderList.filter(item => item.category_id == cat.category_id)[0]
    var items = category.items.filter(item => item.item_id !== product.item_id);
    if (items.length == 0){
      this.reviewOrderList = this.reviewOrderList.filter(item => item.category_id != cat.category_id)
    }
    else{
      var oldarray = this.reviewOrderList
      var newarray = []
      for (let i = 0; i < oldarray.length; i++){
        if (oldarray[i].category_id == cat.category_id){
          oldarray[i].items = items
        }
        newarray.push(oldarray[i])
      }
      this.reviewOrderList = [...newarray]
    }
    this.failureCaseCount()
  }

  trackByFn(index) {
    return index;
  }

  refreshCategoryData(cat){
    let data = []
    for (let i = 0; i < this.reviewOrderList.length; i++){
      var current_limit = 0
      if (this.reviewOrderList[i].items.length > 0){
        if (cat.category_id == this.reviewOrderList[i].category_id){
          for (let j = 0; j < this.reviewOrderList[i].items.length; j++){
            current_limit += this.reviewOrderList[i].items[j].item_qty
          }
          if (current_limit != 0){
            this.reviewOrderList[i]['current_cart_qty'] = current_limit
          }
          else{
            this.reviewOrderList[i]['current_cart_qty'] = null
          }
        }
        data.push(this.reviewOrderList[i])
      }
      this.failureCaseCount()
    }
    
    this.reviewOrderList = [...data]
    this.failureCount = document.querySelectorAll("div .ping-bg").length;
  }

  qytUpdate(product, qyt, cat, template: any) {
    this.statePersist.amendQtyGoogleanalyticsEvent()
    if (qyt == 0){
      qyt = 1
      for (let i = 0; i < this.reviewOrderList.length; i++){
        for (let j = 0; j < this.reviewOrderList[i].items.length; j++) {
          if (this.reviewOrderList[i].items[j]['product_id'] == product.product_id) {
            this.reviewOrderList[i].items[j]['item_qty'] = '0'
          }
        }
      }
      this.removePopup(template, cat, product, 'type1')
    }
    else{
      this.productService.qytUpdate({ 'item_id': parseInt(product.item_id), 'qty': qyt, 'collect_totals':true})
      .subscribe(
        data => {
          if (data.response) {
            if (data.status == 1169) {
              this.updateCategoryArray(product, cat)
            }
            else if (data.status == 2211){
              this.alertService.error(data.response)
              this.getCategoryProductListing()
            }
            else if(data.status == 2212){
                
              for (let i = 0; i < this.reviewOrderList.length; i++){
                for (let j = 0; j < this.reviewOrderList[i].items.length; j++) {
                  var qty = this.reviewOrderList[i].items[j]['item_qty'];
                  if (this.reviewOrderList[i].items[j]['product_id'] == product.product_id) {
                    this.reviewOrderList[i].items[j]['item_qty'] = qty;
                  }
              }}
              this.alertService.error(data.response)
            }
            else if(data.status == 1180){
              localStorage.setItem('closeStorInfoMessage', data.response.msg)
              document.getElementById("openclosedStoreInfo").click();
              for (let i = 0; i < this.reviewOrderList.length; i++){
                for (let j = 0; j < this.reviewOrderList[i].items.length; j++) {
                  var qty = this.reviewOrderList[i].items[j]['item_qty'];
                  if (this.reviewOrderList[i].items[j]['product_id'] == product.product_id) {
                    this.reviewOrderList[i].items[j]['item_qty'] = qty;
                  }
              }
            }
            const currentUrl = this.router.url;
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              this.router.navigate([currentUrl]);
            });
            }
            else if (data.status == 1163) {
              this.updateCategoryArray(product, cat)
              this.toastService.error(data.response)
            }
            else {
              for (let i = 0; i < this.reviewOrderList.length; i++){
                for (let j = 0; j < this.reviewOrderList[i].items.length; j++) {
                  if (this.reviewOrderList[i].items[j]['item_id'] == product.item_id) {
                    this.reviewOrderList[i].items[j]['item_qty'] = qyt
                    this.reviewOrderList[i].items[j]['row_total'] = data.response.row_total
                  }
                }
              }
            }
            this.refreshCategoryData(cat)
          }

        }
      );
    }
    
  }

  addMoreProductsRedirection(cat){
    var url = '/product/listing/' + cat.category_id + '-' + cat.url_key;

    this.statePersist.setLocalStorage('product_data', {'brand_filter':''}); 
    this.googleAnalyticsService.eventEmitter(SharedConsts.REVIEW_ADD_PRODUCT_CLICK_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.REVIEW_ADD_PRODUCT_CLICK_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    this.router.navigate([url])
  }

  removeItem(cat, product){
    let fordata;
    fordata = {'item_id': product.item_id,'collect_totals':true}
    this.bsModalRef.hide();
    this.cartService.removeItem(fordata)
      .subscribe(
        data => {
          if (data.response) {
            this.bsModalRef.hide();
            if(data.status == 1180){
              localStorage.setItem('closeStorInfoMessage', data.response.msg)
              document.getElementById("openclosedStoreInfo").click();
              const currentUrl = this.router.url;
              this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this.router.navigate([currentUrl]);
              });
            }
            else if (data.status == 2212){
              this.alertService.error(data.response)
            }
            else if (data.status == 2211){
              this.alertService.error(data.response)
              this.getCategoryProductListing()
            }
            else{
              this.updateCategoryArray(product, cat)
              this.refreshCategoryData(cat)
              this.alertService.success('Product removed.')
            }
            
            
          }
            
          }

      )

  }

  cancleRequest(cat, product){
    this.bsModalRef.hide()
    for (let i = 0; i < this.reviewOrderList.length; i++) {
      if (this.reviewOrderList[i]['category_id'] == cat.category_id) {
        for (let j = 0; j < this.reviewOrderList[i].items.length; j++) {
          if (this.reviewOrderList[i].items[j].product_id == product.product_id){
            this.reviewOrderList[i].items[j]['item_qty'] = '1'
          }
          
        }
        
      }
    }
  }

  failureCaseCount(){
    var doc = document.body.getElementsByClassName('pink-bg')
    this.failureCount = doc.length
  }

  ngAfterViewChecked(){
    this.failureCaseCount()
  }

  validate() {
    this.googleAnalyticsService.eventEmitter(SharedConsts.REVIEW_ORDER_SUMMARY_CLICK_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.REVIEW_ORDER_SUMMARY_CLICK_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    this.cartService.validate()
    .subscribe(
      data => {
        if (data.response) {
          if (data.status == 1144) {
            this.toastService.error(data.response);
            this.statePersist.setLocalStorage('product_data', {'brand_filter':''});
            this.router.navigate(['/product/listing/All']);
          }
          else if (data.status == 1145){
            this.toastService.error(data.response)
          }
          else{
            this.router.navigate(['/mycart/order-summary']);
          }
        }
        else if (!data.response){
          this.getCategoryProductListing()
        }
      }
    );
  }
}
